import {
  GetProfile,
  GetStat,
  GetStatRDAnalytics,
  GetPDAnalytics,
  Department,
  LoginResponse,
  ProgressInfo,
  RolePermissions
} from "../autogen/api";

export interface LabelAndValue {
  value: string;
  label: string;
}
export type SelectableProfile = GetProfile & { department?: Department } & {
  selected?: boolean;
  disabled?: boolean;
};
export type UserStats = {
  [key: string]: { stats: GetStat; profile: GetProfile };
};
export type UserXStats<T> = {
  id: string;
  name: string;
  department?: Department;
  axis: T;
};
export type UserRDStats = UserXStats<GetStatRDAnalytics>;
export * from "../autogen/api";
export type UserPDStats = UserXStats<GetPDAnalytics[]>;
export type UserProgressStats = UserXStats<ProgressInfo[]>;
// export type UserPMStats = UserXStats<GetPMAnalytics>;
export enum InstructionLevel {
  None = "none",
  Alert = "alert",
  Info = "info",
  Confirm = "confirm",
  Warning = "warning",
  Danger = "danger"
}
// Update not fired even when object in store
export class Instruction {
  level?: InstructionLevel;
  message?: string;
  update(level?: InstructionLevel, message?: string) {
    this.level = level;
    this.message = message;
  }
  clear() {
    this.level = undefined;
    this.message = undefined;
  }
}

export type Auth = Omit<LoginResponse, "accessToken" | "refreshToken"> &
  Partial<Pick<LoginResponse, "accessToken" | "refreshToken">>;

export type navMenu = {
  id: string;
  name: string;
  path: string;
  role?: Function;
  child?: {}[];
};

export interface permissions {
  employee: string;
  applicant: string;
  analysis: string;
  manage: string;
  specialManage: string;
  asBroadcast: string;
  employeeStats: string;
  applicantStats: string;
  [key: string]: string;
}

export type expandRole = RolePermissions & { [key: string]: string };
